module.exports = __webpack_public_path__ + "static/media/Background_1.f67ec989.webp";